// extracted by mini-css-extract-plugin
export var actionText = "_ja-4";
export var container = "_ja-0";
export var leftSection = "_ja-1";
export var rightSection = "_ja-2";
export var settingsButton = "_ja-6";
export var settingsIcon = "_ja-7";
export var shortcut = "_ja-5";
export var shortcutGroup = "_ja-3";